import React, { useContext, useEffect } from "react";
import NavBar from "../../components/NavBar";
import { useHistory } from "react-router";
import {
  Server as ServerIcon,
  // Settings as SettingsIcon,
  // User as UserIcon,
  Users as UsersIcon,
  Monitor as MonitorIcon,
  BarChart as BarChartIcon,
  Tool as ToolIcon,
  Truck,
} from "react-feather";
import { UseMe } from "../../api/users/Me.api";
import {
  AuthContext,
  AuthContextDispatchContext,
} from "../../context/auth/AuthContext";

const Dashboard = {
  href: "/app/dashboard",
  icon: BarChartIcon,
  title: "Dashboard",
};

const Plants = {
  href: "/app/plants",
  icon: ServerIcon,
  title: "Plants",
};

// const Account = {
//     href: '/app/account',
//     icon: UserIcon,
//     title: 'Account'
// }

// const Settings = {
//     href: '/app/settings',
//     icon: SettingsIcon,
//     title: 'Settings'
// }

const Users = {
  href: "/app/customers",
  icon: UsersIcon,
  title: "Customers",
};

const Support = {
  href: "/app/support",
  icon: Truck,
  title: "Support",
};

const Installers = {
  href: "/app/installers",
  icon: ToolIcon,
  title: "Installers",
};

const Ekloks = {
  href: "/app/ekloks",
  icon: MonitorIcon,
  title: "Ekloks",
};

const setMenu = (type) => {
  switch (type) {
    case "Admin":
      return [Dashboard, Plants, Support, Ekloks, Installers, Users];

    case "Support":
      return [Dashboard, Plants, Ekloks];

    case "Installer":
      return [Dashboard];

    case "Customer":
      return [Dashboard];

    default:
      return [];
  }
};

const NavBarContainer = ({ onMobileClose, openMobile }) => {
  const history = useHistory();
  const { token } = useContext(AuthContext);
  const { deleteToken } = useContext(AuthContextDispatchContext);
  const { content, error } = UseMe(token);

  useEffect(() => {
    if (error) {
      deleteToken();
      history.push("/");
    }
  }, [error, deleteToken, history]);

  return (
    <NavBar
      onMobileClose={onMobileClose}
      openMobile={openMobile}
      items={setMenu(content ? content.groups[0].name : "")}
      user={content}
    />
  );
};

export default NavBarContainer;
